import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { getAuth } from 'firebase/auth';

export const useAdminAuth = defineStore('admin', () => {
    const admin = ref(null);
    const token = ref(null);
    const estAdmin = ref(false);
    const verificationTerminee = ref(false);

    // Computed pour vérifier si l'admin est connecté
    const adminConnecte = computed(() => !!admin.value);

    // Vérifier les claims admin
    const verifierClaimsAdmin = async () => {
        try {
            if (!admin.value) {
                estAdmin.value = false;
                return false;
            }

            const tokenResult = await admin.value.getIdTokenResult(true);
            estAdmin.value = tokenResult.claims.admin === true;
            return estAdmin.value;
        } catch (error) {
            console.error("Erreur lors de la vérification des claims admin:", error);
            estAdmin.value = false;
            return false;
        } finally {
            verificationTerminee.value = true;
        }
    };

    // Connexion de l'admin et vérification des droits
    const connexionAdmin = async (user) => {
        try {
            admin.value = user;
            
            if (user) {
                // Récupérer le token
                token.value = await user.getIdToken(true);
                console.log("Token récupéré :", token.value);
                
                // Vérifier les claims admin
                await verifierClaimsAdmin();
            } else {
                estAdmin.value = false;
                token.value = null;
            }
        } catch (error) {
            console.error("Erreur lors de la connexion admin:", error);
            deconnexionAdmin();
        }
    };

    const deconnexionAdmin = () => {
        admin.value = null;
        token.value = null;
        estAdmin.value = false;
        verificationTerminee.value = false;
    };

    // Fonction pour faire une requête API sécurisée avec vérification admin
    const fetchWithAuth = async (url, options = {}) => {
        if (!admin.value) {
            throw new Error("Admin non connecté");
        }

        // Vérifier les droits admin avant la requête
        const droitsValides = await verifierClaimsAdmin();
        if (!droitsValides) {
            throw new Error("Droits administrateur requis");
        }

        // Toujours récupérer un token frais
        token.value = await admin.value.getIdToken(true);
        if (!token.value) {
            throw new Error("Token manquant");
        }

        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
            ...options.headers,
            'Authorization': `Bearer ${token.value}`,
        };

        return fetch(url, { ...options, headers });
    };

    // Initialiser l'état depuis Firebase Auth
    const initialiserEtat = async () => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            await connexionAdmin(user);
        } else {
            verificationTerminee.value = true;
        }
    };

    return {
        // États
        admin,
        adminConnecte,
        token,
        estAdmin,
        verificationTerminee,
        // Actions
        connexionAdmin,
        deconnexionAdmin,
        verifierClaimsAdmin,
        fetchWithAuth,
        initialiserEtat
    };
});